// extracted by mini-css-extract-plugin
module.exports = {"largeContainer":"index_largeContainer__ADziO","layoutContent":"index_layoutContent__GAm0K","outlet":"index_outlet__jo5gi"};